import React from 'react';

const InputField = ({ label, id, error, className = '', ...props }) => {
  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      {label && (
        <label htmlFor={id} className="text-sm font-medium text-amber-900">
          {label}
        </label>
      )}
      <input
        id={id}
        className={`border rounded-lg px-4 py-3 text-gray-800 bg-white focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all ${
          error ? 'border-red-400' : 'border-amber-200'
        }`}
        {...props}
      />
      {error && <span className="text-red-500 text-sm">{error}</span>}
    </div>
  );
};

export default InputField;
